import React, { Component } from "react";
import HomeNav from "../src/pages/Home/HomeNav";
import HomeFooter from "../src/pages/Home/HomeFooter";
import RevampResposibleDisclosure from "../src/pages/ResposibleDisclosure/RevampResposibleDisclosure";

class ResponsibleDisclosure extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<>
				<HomeNav />
				<RevampResposibleDisclosure />
				<HomeFooter />
			</>
		);
	}
}

export default ResponsibleDisclosure;
